export type InputListenerEntry = {
  target: EventTarget;
  type: string;
  handler: EventListenerOrEventListenerObject;
  options?: AddEventListenerOptions | boolean;
};

export abstract class InputControllerBase {
  protected abstract readonly listeners: InputListenerEntry[];

  attach(): void {
    for (const { target, type, handler, options } of this.listeners) {
      target.addEventListener(type, handler, options);
    }
  }

  detach(): void {
    for (const { target, type, handler, options } of this.listeners) {
      target.removeEventListener(type, handler, options);
    }
  }
}
